/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import Auth from "../../shared/Auth";
import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import BaseCom from "../BaseCom";
import Icon from "../Icon";
import LoadingAlert from "../LoadingAlert";
import Tick from "../Tick";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import { Dropdown } from "react-bootstrap";

class ChatIcon extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            unread: 0,
            list: []
        };
        this.tick = this.tick.bind(this);
        this.click = this.click.bind(this);
        this.cropMessage = this.cropMessage.bind(this);
    }

    componentDidMount() {
        this.tick();
    }

    tick() {
        qreq.get('/api/chat/recent/list', j => {
            if(j.list) {
                var unread = 0;
                j.list.forEach(i => {
                    if(!i.isRead)
                        unread++;
                });
                this.setState({ list: j.list, unread: unread });
            }
        });
    }

    click(item) {
        this.props.navigate('/chat/' + item.id);
        if(!item.isRead) {
            item.isRead = true;
            this.setState({ list: [...this.state.list], unread: this.state.unread - 1 });
        }
    }

    cropMessage(msg) {
        if(!msg)
            return '';
        if(msg.length > 50)
            return msg.substr(0, 50) + '...';
        return msg;
    }

    new = () => {
        this.props.navigate('/chat/channel/new');
    }

    render() {
        return <>
            <Tick onTick={this.tick} interval={10000} />
            <Dropdown className="ms-2 no-arrow">
                <Dropdown.Toggle variant={this.state.unread > 0 ? 'warning' : 'secondary'}>
                    <Icon icon="faMessage" />
                    {this.state.unread > 0 ? <span className="ms-1">{this.state.unread}</span> : null}
                </Dropdown.Toggle>
                <Dropdown.Menu variant="dark" style={{maxHeight: '80vh', overflow: 'auto'}}>
                    {!this.state.list ? <Dropdown.Item>Loading...</Dropdown.Item> : this.state.list.length === 0 ? <Dropdown.Item>No messages.</Dropdown.Item> : this.state.list.map(i => <Dropdown.Item key={i.id} onClick={() => this.click(i)}>
                        {!i.isRead ? <Icon icon="faEnvelope" className="me-2 text-warning" /> : null}
                        <div className="d-block smaller">{i.patientName}</div>
                        <div>{this.cropMessage(i.lastMessage)}</div>
                        <small className="d-block smallest"><i>By: {i.lastUserName}</i></small>
                        <small className="d-block smallest"><i>On: {Globals.toMDYHMLocalDateStringOrDiff(i.lastWriteDate)}</i></small>
                    </Dropdown.Item>)}
                    {Auth.hasRole('admin') && <Dropdown.Item onClick={this.new}>New Channel</Dropdown.Item>}
                </Dropdown.Menu>
            </Dropdown>
        </>;
    }
}

export default withParamsAndNavigate(ChatIcon);